// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39QUs","label":"styles_label__28q5n"};